<template>
  <div class="footer-list">
    <div class="footer-fade"></div>
    <div class="spacer-3"></div>
    <div class="lore-cta" v-if="loreCta">
      <div class="ending-container">
          <div class="ending-cta">
            <span>Surf the Sneakernet</span>
            <a href="/" class="button cta-button"><span>Join the Club</span> →</a>
            <span>Carry What Matters</span>
          </div>
        </div>
    </div>
    <div class="grid">
      <div class="column-four column-align-left footer-nav">
        <a href="https://twitter.com/usbclub" target="_blank">Twitter</a>
        <br>
        <a href="https://www.instagram.com/bringyourusb" target="_blank">Instagram</a>
        <br>
        <a href="https://www.are.na/teal/usb-club" target="_blank">Are.na</a>
        <br>
        <br>
        <a href="/" @click.prevent="transitionTo('/about')">About</a>
        <br>
        <a href="/" @click.prevent="transitionTo('/careering')">Careering</a>
        <br>
        <br>
        <a href="/" @click.prevent="transitionTo('/support')">Support<br>Privacy</a>
      </div>
      <div class="footer-mobile-show">
        <div class="spacer-3"></div>
      </div>
      <div class="column-four column-align-left">
        <div class="footer-fitb">
          <div class="fitb-logo-set">
            <img src="/figures/fitb-1.png" />
            <img src="/figures/fitb-2.png" />
            <img class='clubby' src="/figures/fitb-3.png" />
            <img src="/figures/fitb-4.png" />
          </div>
          <!-- <img src="/figures/fitb.png" /> -->
          <div class="fitb-label">
            Fill in the Blank Inc.<br>
            2025 New York, NY
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterBottom",
  props: {
    loreCta: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    transitionTo(path) {
      this.$router.push(path);
    },
  },
  mounted() {},
};
</script>

<style>

.footer-list {
  padding-top: 0;
  padding-bottom: 16rem;
  background: #272727;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background-image: url('/figures/background-texture.png');
  background-size: 100% auto;
  background-repeat: repeat-y;
  background-blend-mode: difference;
}

.footer-nav {
  color: #DDEDFF;
  font-family: "ISO", monospace;
  font-size: 14px;
  letter-spacing: 0.2px;
  line-height: 150%;
}

.footer-nav a,
.footer-nav a:visited {
  text-decoration: none;
  color: #DDEDFF;
  transition: all 350ms ease-in-out;
}

.footer-nav a:hover {
  color: white;
  text-decoration: none;
}

.fitb-label {
  color: #FFF;
  text-align: right;
  font-family: "ISO";
  font-size: 1.6rem;
  font-style: italic;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.footer-fitb {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}

.footer-fitb img {
  height: 4rem;
  width: auto;
  margin-bottom: 0.8rem;
}

.footer-mobile-show {
  display: none;
}

@media screen and (max-width: 700px) {
  .footer-mobile-show {
    display: block;
  }
}

.footer-fade {
  width: 100%;
  height: 80px;
  background: linear-gradient(180deg, #1c1c1cc4 0%, rgba(28, 28, 28, 0.00) 100%);
}

.fitb-logo-set {
  display: flex;
  flex-direction: row;
  grid-gap: 0;
  align-items: center;
  margin-bottom: 0.8rem;
  margin-right: -0.8rem;
}

.fitb-logo-set img {
  display: flex;
  margin: 0;
  height: 42px;
  width: 42px;
}

.fitb-logo-set img.clubby {
  opacity: 0;
  transform: scale(0.9);
  transition: all 200ms ease-in-out;
}

.fitb-logo-set img.clubby:hover,
.fitb-logo-set img.clubby:active {
  opacity: 1;
  transform: scale(1);
}

.lore-cta {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

</style>
